import { I4BCellType, I4BColumnConfiguration, I4BColumnRowGroupConfiguration } from '../configurations/i4b-column-configuration';
import { HeaderType, I4BColumnHeader } from '../models/i4b-column-header.model';
import { I4BColumnOptions } from '../options';
import { I4BBasicColumn } from './i4b-basic.column';

interface CreatedGroupColumnConfiguration extends I4BColumnConfiguration {
  rowGroupParams: Partial<{
    createdAt: Partial<I4BColumnRowGroupConfiguration>;
    createdBy: Partial<I4BColumnRowGroupConfiguration>;
  }>;
}

export class CreatedGroupColumn extends I4BBasicColumn {
  columnId = 'e1f820e6-9f86-11ec-9da8-0023a40210d0-created-group';
  className = CreatedGroupColumn;

  constructor(
    customHeader: Partial<I4BColumnHeader> | undefined,
    customConfig: Partial<CreatedGroupColumnConfiguration>,
    customOptions?: Partial<I4BColumnOptions>
  ) {
    super(
      {
        ...customHeader,
        displayName: customHeader?.displayName ?? 'CREATED FULL',
        type: HeaderType.BASIC
      },
      {
        cell: { type: I4BCellType.BASIC },
        id: customConfig.id,
        concept: customConfig.concept,
        isDefault: false,
        marryChildren: true,
        rowGroupParams: customConfig?.rowGroupParams,
        children: [
          new I4BBasicColumn(
            { displayName: 'CREATED AT', type: HeaderType.BASIC },
            {
              translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.CREATED_AT',
              id: 'createdAt',
              isDefault: false,
              sortProperty: 'createdAt',
              concept: customConfig.concept,
              cell: { type: I4BCellType.DATE },
              rowGroupParams: customConfig?.rowGroupParams?.createdAt
            },
            {
              order: 980
            }
          ),
          new I4BBasicColumn(
            { displayName: 'CREATED BY', type: HeaderType.BASIC },
            {
              translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.CREATED_BY',
              id: 'createdBy',
              isDefault: false,
              sortProperty: 'createdBy',
              concept: customConfig.concept,
              width: 165,
              cell: {
                type: I4BCellType.USER_CELL
              },
              rowGroupParams: customConfig?.rowGroupParams?.createdBy
            },
            {
              order: 981
            }
          )
        ]
      },
      { ...customOptions, customId: customConfig.id ?? undefined }
    );
  }
}
